import { render, staticRenderFns } from "./HomeDesktop.vue?vue&type=template&id=c465f01c&scoped=true&"
import script from "./HomeDesktop.vue?vue&type=script&lang=js&"
export * from "./HomeDesktop.vue?vue&type=script&lang=js&"
import style0 from "./HomeDesktop.vue?vue&type=style&index=0&id=c465f01c&prod&module=classes&lang=scss&"
import style1 from "./HomeDesktop.vue?vue&type=style&index=1&id=c465f01c&prod&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["classes"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c465f01c",
  null
  
)

export default component.exports